module.exports = __webpack_public_path__ + "img/banner.67c01853.jpg";